import React, { useState } from 'react';
import { LazyBlock } from '../../../types/api/Block';
import { BlockType } from '../../../types/api/ElementType';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import Btn, { BtnModifier } from '../../../components/molecules/Btn';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { Icons } from '../../../components/atoms/SVG';
import { ModalDialogModifier } from '../../../components/organisms/ModalDialog/ModalDialog.modifier';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { PageStatisticsBlock } from '../../PageStatistics';

export function PageStatisticsButton({ pageStatistics }: { pageStatistics: LazyBlock<BlockType.pagestatistics> }) {
  const { t } = useSonTranslation('PageInteractions');
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const statisticsTranslation = t('statistics.title');

  return (
    <div className="page-interactions__button-container">
      <Btn
        onClick={() => setModalOpen(true)}
        tooltipPlacement={TooltipPlacement.TOP}
        type="button"
        svgSpriteId={Icons.ANALYSIS}
        text={statisticsTranslation}
        titleText={statisticsTranslation}
        hiddenText
        modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
      />
      {modalOpen && (
        <ModalDialog
          modifier={ModalDialogModifier.WIDE}
          closeModal={() => setModalOpen(false)}
          headline={statisticsTranslation}
        >
          <PageStatisticsBlock {...pageStatistics} />
        </ModalDialog>
      )}
    </div>
  );
}
